<template>
  <div class="account">
    <GlobalInfoBar title="商品列表" />
    <GlobalChunk :padding="[20, 20, 20, 20]">
      <GlobalForm :form-item-list="formItemList" :inline="true" round @handleConfirm="query" confirmBtnName="查询">
        <div slot="AddSlot">
          <el-button size="small" type="primary" icon="el-icon-plus" @click="addOrEdit({})">添加商品</el-button>
        </div>
      </GlobalForm>

      <GlobalTable ref="GlobalTable" :columns="tableColumns" :data="tableData" :currentPage="curPage"
        :total="totalElements" @handleCurrentChange="currentChange">
        <!-- <el-table-column label="启用禁用" slot="is_open" align="center">
          <template slot-scope="{ row }">
            <el-switch v-model="row.is_open" @change="switchChange(row)"></el-switch>
          </template>
        </el-table-column> -->
        <el-table-column label="最新操作人" slot="user_name" align="center">
          <template slot-scope="{ row }">

           {{ row.user_name }}-{{ row.mobile }}

          </template>
        </el-table-column>
        <el-table-column label="操作" slot="operation" align="center">
          <template slot-scope="{ row }">

            <el-button type="text" @click="addOrEdit(row)" style="margin-right: 5px;">编辑</el-button>
            <el-button type="text" @click="delate(row.goods_id)">删除</el-button>

          </template>
        </el-table-column>
      </GlobalTable>
    </GlobalChunk>

    <el-dialog :title="dialog.form.goods_id ? '编辑商品' : '新增商品'" :visible.sync="dialog.isShow" width="500px"
      :before-close="dialogClose">

      <el-form ref="dialogForm" :model="dialog.form" label-width="100px" size="small" :rules="dialog.rules">
        <el-form-item prop="goods_name" label="商品名称">
          <el-input v-model="dialog.form.goods_name" placeholder="请输入商品名称" maxlength="30" show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item prop="goods_price" label="商品零售价">
          <div class="price-input">
            <el-input-number v-model="dialog.form.goods_price" :controls-position="'right'" :min="1" :max="10000">
            </el-input-number>
            <span class="unit">元/个</span>
          </div>
        </el-form-item>

        <div class="form-footer">
          <el-button size="small" @click="dialogClose()">取消</el-button>
          <el-button type="primary" size="small" @click="confirm">确定</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { goodsList, goodsSet, openOperate, goodsDel } from "@/utils/request/memberBackendManagement";

export default {
  name: "account",
  data() {
    return {

      formItemList: [
        {
          key: 'goods_name',
          type: 'input',
          labelName: '商品名称:',
          placeholder: '请输入产品名称'
        },
        // {
        //   key: 'is_open',
        //   idKey: 'id',
        //   labelKey: 'name',
        //   type: 'select',
        //   labelName: '商品状态:',
        //   option: [{ name: '全部', id: null }, { name: '启用', id: 1 }, { name: '禁用', id: 0 }],
        //   placeholder: '请选择商品状态'
        // },
      ],
      search: {},
      tableColumns: [
        { label: "商品名称", prop: "goods_name" },
        { label: "零售价（元/个）", prop: "goods_price" },
        // { label: "当前绑定会员方案", prop: "plan_str" },
        // { slotName: "is_open" },
        { slotName: "user_name" },
        // { label: "最新操作人", prop: "user_name" },
        { label: "最新操作时间", prop: "add_time" },
        { slotName: "operation" }
      ],
      tableData: [],
      curPage: 1,
      totalElements: 0,
      pageSize: 10,
      dialog: {
        isShow: false,
        form: {
        },
        rules: {
          goods_name: [{ required: true, message: '请输入商品名称', trigger: 'blur' },
          { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' },
          ],
          goods_price: [{ required: true, message: '请输入商品零售价', trigger: 'blur' },
          ],
        },
      }
    }
  },
  mounted() {
    this.getGoodsList()
  },
  methods: {
    getGoodsList() {
      goodsList({
        page: this.curPage,
        ...this.search
      }).then(res => {
        // res.data.map((ele) => {
        //   ele.is_open = ele.is_open == 0 ? false : true
        // })
        this.tableData = res.data
        this.totalElements = res.count || 0
      })
    },
    query(data, cd) {
      this.search = data
      this.curPage = 1
      this.getGoodsList()
    },
    currentChange(page) {
      this.curPage = page
      this.getGoodsList()
    },
    // switchChange(row) {
    //   const { is_open, goods_id } = row
    //   this.$alert(`是否确认${is_open ? '开启' : '禁用'}？`, '确认弹窗', {
    //     confirmButtonText: '确定',
    //     callback: action => {
    //       if (action == 'confirm') {
    //         openOperate({
    //           type: '3',
    //           val: is_open ? 1 : 0,
    //           id: goods_id
    //         }).then(res => {
    //           this.$message({
    //             message: '操作成功',
    //             type: 'success'
    //           });
    //           this.getGoodsList()
    //         })
    //       } else {
    //         row.is_open = !is_open
    //       }
    //     }
    //   });

    // },
    addOrEdit(row) {
      this.dialog.form = row
      this.dialog.isShow = true
    },
    confirm() {
      this.$refs.dialogForm.validate(valid => {
        if (!valid) return
        const { goods_id, goods_name, goods_price } = this.dialog.form
        this.$alert(`是否确认${goods_id ? '编辑' : '新增'}？`, '确认弹窗', {
          confirmButtonText: '确定',
          callback: action => {
            if (action == 'confirm') {
              goodsSet({ goods_id, goods_name, goods_price }).then(res => {
                this.$message.success(res.msg)
                this.dialogClose()
              }).catch(err => {
              })
            }
          }
        });
      })
    },
    dialogClose() {
      this.$refs['dialogForm'].resetFields();
      this.dialog.form = {}
      this.dialog.isShow = false
      this.getGoodsList()
    },
    delate(goods_id) {
      this.$alert(`是否确认删除？`, '确认弹窗', {
        confirmButtonText: '确定',
        callback: action => {
          if (action == 'confirm') {
            goodsDel({
              goods_id
            }).then(res => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.getGoodsList()
            })
          }
        }
      });

    },

  }
}
</script>

<style scoped lang="scss">
.goods-form {
  padding: 20px 30px 0;
}

.goods-form .el-form-item {
  margin-bottom: 20px;
}

.price-input {
  display: flex;
  align-items: center;
}

.price-input .el-input-number {
  width: 180px;
  margin-right: 10px;
}

.price-input .unit {
  color: #606266;
  font-size: 14px;
}

.form-footer {
  display: flex;
  justify-content: flex-end;
  margin: 30px;

}

.form-footer .el-button {
  width: 80px;
  margin-left: 15px;
}
</style>
